module.exports = __webpack_public_path__ + "static/media/TORRES STRAIT ISLAND REGIONAL.925f3d46.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_areas/TORRES STRAIT ISLAND REGIONAL.svg
// module id = 587
// module chunks = 0